module.exports = __webpack_public_path__ + "static/media/2.c05c6a84.jpg";